module.exports = __webpack_public_path__ + "img/report-mc.0145dd1a.svg";